import React from "react";
import { useSelector } from "react-redux";
import { useGetTaskQuery } from "../../features/Task/TaskApi";
import Task from "../Task/Task";

const TaskList = () => {
  const { data: tasks, isError, isLoading } = useGetTaskQuery();
  const filterKey = useSelector((state) => state.filter);

  const filterByProjects = () => {
    return (task) =>
      filterKey?.projects ? filterKey?.projects.includes(task.project.projectName) : task;
  };

  const searchFilter = () => {
    return (task) =>
      filterKey?.search
        ? task.taskName.toLowerCase().includes(filterKey?.search.toLowerCase())
        : task;
  };

  let content;

  if (isLoading) {
    content = <div className="m-2 text-center">Loading...</div>;
  } else if (!isLoading && isError) {
    content = <div className="m-2 text-center">There was an error.</div>;
  } else if (!isLoading && !isError && tasks?.length === 0) {
    content = <div className="m-2 text-center">No conversations found!</div>;
  } else if (!isLoading && !isError && tasks?.length > 0) {
    content = tasks
      .filter(searchFilter())
      .filter(filterByProjects())
      .map((task) => <Task key={task.id} task={task}></Task>);

    
    if (content.length === 0) {
      return <div>No result found!</div>
    }

    return <div className="lws-task-list">{content}</div>;
  }
};
export default TaskList;
